export default __webpack_public_path__ + "static/media/wercker.d51c6964.svg";